<template>
  <f7-page>
    <f7-navbar :title="itemDefinition.title" back-link="back" style=""></f7-navbar>
    <img
      :src="`${ImageUrlBuilder.url64(itemDefinition.detailImgUrl, storeId)}`"
      style="width: 100%;">
    <div>{{ itemDefinition.description }}</div>
  </f7-page>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'
import ItemCard from '../components/ItemCard'

export default {
  dependencies: ['ImageUrlBuilder'],
  props: ['itemIdPathParam'],
  computed: {
    ...mapState('itemModule', ['cart']),
    ...mapGetters(['storeId', 'currentMenu']),
    itemDefinition () {
      return this.currentMenu.items[this.itemIdPathParam]
    }
  },
  methods: {
    ...mapActions('itemModule', ['addNewItemToCart'])
  },
  components: {
    ItemCard
  }
}
</script>

<style lang="scss" scoped>
.hr-text {
  line-height: 1em;
  position: relative;
  outline: 0;
  border: 0;
  color: black;
  text-align: center;
  height: 1.5em;
  opacity: .9;
  margin: 20px 0px;
  &:before {
    content: '';
    // use the linear-gradient for the fading effect
    // use a solid background color for a solid bar
    // #818078
    background: linear-gradient(to right, transparent, #818078, transparent);
    position: absolute;
    left: 0;
    top: 50%;
    width: 100%;
    height: 1px;
  }
  &:after {
    content: attr(data-content);
    position: relative;
    display: inline-block;
    color: black;

    padding: 0 .5em;
    line-height: 1.5em;
    // this is really the only tricky part, you need to specify the background color of the container element...
    color: #818078;
    background-color: #FFFFFF;
  }
}
</style>
